export default "__VITE_PUBLIC_ASSET__585ff386__"